<template>
  <div class="checkImgListCon">
    <!-- 表单勾选弹窗 -->
    <k-dialog
      class="checkImgList"
      ref = "checkImgList"
      :options = "{title: title, center:true, width: '60%',height:900,top:'0',destroyOnClose:true,
      isCanClickClose: false,showClose: true,
      onCloseBefore: onCloseBefore,
      buttons:[{text:'取消', handler: onCloseBefore},
      {text:btnText, handler: confirmBtnHandler}]}">

      <div class="oper-img">
        <el-checkbox style="font-size: 0.18rem;" size="large" v-model="isAllCheck" @change='bacthCheckAll'>全选</el-checkbox>
      </div>
      <div class="batchPrintModelCon">
        <div class="printCon">
            <div class="batchPrintListCover">
              <template v-for="(item,index) in formList">
                <div class="batch_print_row"  :key="index+item.IMG_CLS_NAME">
                  <div class="batch_print_item">
                    <el-checkbox :ref="'check' + index"  size="medium" v-model="checkList[index]" @change='checkPrint($event,item,index)' class="batchPrintListCover-check">{{item.IMG_CLS_NAME}}</el-checkbox>
                    <!-- <span>{{item.IMG_CLS_NAME}}</span> -->
                  </div>
                </div>
              </template>
            </div>
        </div>
      </div>
    </k-dialog>
  </div>
</template>

<script>
import kDialog from "../../common/dialog.vue";

export default {
  components: {
    kDialog
  },
  props: ["isShowBox", "title", "formList","btnText"],
  data () {
    return {
      isAllCheck: false,
      checkList:[],
      downLoadList:[],
    };
  },
  watch: {
    downLoadList () {
      if (this.downLoadList.length < this.formList.length) {
        this.isAllCheck = false;
      }
      if (this.downLoadList.length == this.formList.length) {
        this.isAllCheck = true;
      }
      if (this.downLoadList.length == 0) {
        this.isAllCheck = false;
      }
    }
  },
  computed: {
  },
  async created () {
  },
  mounted () {
    this.$refs.checkImgList.open();
  },
  beforeRouteLeave (to, from, next) {},
  beforeDestroy () {},
  methods: {
    onCloseBefore (){
      //取消或者关闭
      this.$emit("closeImgList");
      this.cleanData();
    },
    confirmBtnHandler (){
      return new Promise(resolve=>{
        this.$emit("confirmBtnHandler", this.downLoadList, (flag)=>{
          resolve(flag);
        });
        this.cleanData();
      });
     
    },
    cleanData () {
      //关闭批量打印弹框，选择都置为非选中状态
      // this.isAllCheck = false;
      // this.formList.forEach((item,index)=>{
      //   item.checkFlag = false;
      // });
    },
    //表单全选
    bacthCheckAll (val) {
      let oldArr = this.formList;
      if (val) {
        this.downLoadList = [];
        oldArr.forEach((item, index) => {
          this.checkList[index] = true;
          this.downLoadList.push(item);
        });
      } else {
        oldArr.forEach((item, index) => {
          this.checkList[index] = false;
        });
        this.downLoadList = [];
      }
    },
    //单独的批量打印勾选框
    checkPrint (flag,val,index) {
      if (this.checkList[index] == true) {
        //如果勾选，将图片添加到删除列表
        this.downLoadList.push(val);
      }
      if (this.checkList[index] == false) {
        this.downLoadList = this.downLoadList.filter(item => {
          return item.IMG_CLS != val.IMG_CLS;
        });
      }
    },
  }
};
</script>
<style lang="less" scoped>
.checkImgListCon{
  width: 100%;
  height: 100%;
  /deep/.el-dialog .el-dialog__body{
    padding: 25px 45px !important;
  }
  /deep/.el-checkbox__inner{
    width: 18px;
    height: 18px;
  }
  /deep/ .el-checkbox__label{
    font-size: 14px;
  }
  /deep/ .oper-img .el-checkbox__label{
    // font-size: 16px;
  }
  .el-checkbox{
    font-size: 20px;
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner:after{
      height: 0.07rem;
      left: 0.06rem;
      top: 0.03rem;
    }
  }
  .batchPrintListCover {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .batch_print_row {
      width: 50%;
      padding: 10px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/imageNode/child/checkImgList.vue